/**
 * NodeJS app-config loader -- but in the browser
 *
 * The expectation is that runtime libraries will inject the below global into
 * the environment with the appropriate browser settings.
 */
import key from '../browser-key';

try {
  // Surround in try/catch because process.env is not polyfilled in all build environments
  if (process.env.NODE_ENV !== 'production' && !window[key]) {
    // eslint-disable-next-line
    console.error("Unable to load browser app-config in window[".concat(key, "]. See https://github.com/NerdWallet/app-configs"));
  } // eslint-disable-next-line no-empty

} catch (e) {}

export default window[key];